import { render } from "./BuyIns.vue?vue&type=template&id=624c61e3&scoped=true"
import script from "./BuyIns.vue?vue&type=script&lang=js"
export * from "./BuyIns.vue?vue&type=script&lang=js"

import "./BuyIns.vue?vue&type=style&index=0&id=624c61e3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624c61e3"]])

export default __exports__